import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import IconButton from 'components/@extended/IconButton';
import { Bag2 } from 'iconsax-react';
import { ThemeMode } from 'types/config';
import OrderRequestDrawer from './OrderRequestDrawer';
import { Badge } from '@mui/material';

interface OrderRequestProps {
  setOrderRequestCount: (val: number) => void;
  orderRequestCount: number;
}

const OrderRequest = ({orderRequestCount, setOrderRequestCount}: OrderRequestProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'secondary.200' : 'secondary.200';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'secondary.100';

  return (
    <>
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <Badge
          badgeContent={orderRequestCount}
          color="error"
          overlap="circular"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <IconButton
            color="secondary"
            variant="light"
            onClick={handleToggle}
            aria-label="settings toggler"
            size="large"
            sx={{
              color: 'secondary.main',
              bgcolor: open ? iconBackColorOpen : iconBackColor,
              p: 1
            }}
          >
            <Bag2 variant="Bulk" />
          </IconButton>
        </Badge>
      </Box>
      <OrderRequestDrawer open={open} setOpen={setOpen} setOrderRequestCount={setOrderRequestCount} />
    </>
  );
};

export default OrderRequest;
